<template>
  <div>
    <div class="cardCustom">
      <div class="card cardCustom__side">
        <div class="cardCustom__body">
          <div v-if="loading" :class="{ bgBlur: true }" style="height: 90%; width: 98%"></div>
          <div class="cardCustom__status">
            <span class="cardCustom__header-text">Status</span>
            <span
              v-if="currentInternalCertificate"
              class="cardCustom__status-text"
              :class="getCurrentCertificateStatus()"
              >{{ currentInternalCertificate.certification.name }}</span
            >
            <span v-else class="cardCustom__status-text" :class="getCurrentCertificateStatus()">No Certification</span>
          </div>
          <div class="cardCustom__certificates-progress">
            <div class="cardCustom__certificates">
              <img
                class="cardCustom__certificate"
                :class="getCurrentCertificateIMGClass('Beryl')"
                src="../../assets/img/certificates/noI_leaf_beryl.png"
                alt="Beryl"
              />
              <img
                class="cardCustom__certificate"
                :class="getCurrentCertificateIMGClass('Turquoise')"
                src="../../assets/img/certificates/noI_leaf_turquoise.png"
                alt="Turquoise"
              />
              <img
                class="cardCustom__certificate"
                :class="getCurrentCertificateIMGClass('Jade')"
                src="../../assets/img/certificates/noI_leaf_jade.png"
                alt="Jade"
              />
              <img
                class="cardCustom__certificate"
                :class="getCurrentCertificateIMGClass('Sapphire')"
                src="../../assets/img/certificates/noI_leaf_sapphire.png"
                alt="Sapphire"
              />
            </div>

            <div class="progressBar">
              <div class="progressBar__bar" :style="styleObject">
                <div class="progressBar__bar__marks">
                  <div class="progressBar__bar-mark" :class="getCurrentCertificateBarMarkClass('Beryl')"></div>
                  <div class="progressBar__bar-mark" :class="getCurrentCertificateBarMarkClass('Turquoise')"></div>
                  <div class="progressBar__bar-mark" :class="getCurrentCertificateBarMarkClass('Jade')"></div>
                  <div class="progressBar__bar-mark" :class="getCurrentCertificateBarMarkClass('Sapphire')"></div>
                </div>
              </div>
              <div class="progressBar__values">
                <span
                  class="progressBar__value progressBar__value--beryl"
                  :class="getCurrentCertificateBarValueClass('Beryl')"
                >
                  Beryl
                </span>
                <span
                  class="progressBar__value progressBar__value--turquoise"
                  :class="getCurrentCertificateBarValueClass('Turquoise')"
                >
                  Turquoise
                </span>
                <span
                  class="progressBar__value progressBar__value--jade"
                  :class="getCurrentCertificateBarValueClass('Jade')"
                >
                  Jade
                </span>
                <span
                  class="progressBar__value progressBar__value--sapphire"
                  :class="getCurrentCertificateBarValueClass('Sapphire')"
                >
                  Sapphire
                </span>
              </div>
            </div>
          </div>
          <div class="cardCustom__progress">
            <span class="cardCustom__header-text">Progress to next certificate</span>
            <span class="cardCustom__progress-value">{{ progress_to_next_certification }}%</span>
          </div>
          <div v-if="loading" class="loadingSection lds-dual-ring"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificateProgress',
  props: {
    currentInternalCertificate: {},
    all_achieved_internal_certificates: Array,
    total_certification_score: Number,
    progress_to_next_certification: Number,
    loading: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    styleObject() {
      return {
        '--progress_width': this.percent + '%',
      };
    },
    percent() {
      let result = 100;
      if (this.all_achieved_internal_certificates.length > 0) {
        let sorted_internal_certificates = this.getSortedInternalCertificates();
        let min = sorted_internal_certificates[0].certification_weight;
        let max = 100;
        let difference = max - min;
        let current = this.total_certification_score - min;
        if (current > 0) {
          let widthOfEachMark = sorted_internal_certificates.length * 3;
          result = 100 - (current / difference) * 100 - widthOfEachMark;
        }
      }
      return result;
    },
  },
  mounted() {},
  methods: {
    getCurrentCertificateStatus() {
      let result = { 'cardCustom__status--no_certification': true };

      if (this.currentInternalCertificate) {
        if (this.currentInternalCertificate.certification.name === 'Beryl')
          result = { 'cardCustom__status--beryl': true };
        if (this.currentInternalCertificate.certification.name === 'Turquoise')
          result = { 'cardCustom__status--turquoise': true };
        if (this.currentInternalCertificate.certification.name === 'Jade')
          result = { 'cardCustom__status--jade': true };
        if (this.currentInternalCertificate.certification.name === 'Sapphire')
          result = { 'cardCustom__status--sapphire': true };
      }

      return result;
    },
    getCurrentCertificateIMGClass(certificate_name) {
      let result = '';

      if (this.companyHasThisCertification(certificate_name)) result = { 'cardCustom__certificate--show': true };

      return result;
    },
    getCurrentCertificateBarValueClass(certificate_name) {
      let result = '';

      if (this.companyHasThisCertification(certificate_name)) result = { 'progressBar__value--show': true };

      return result;
    },
    getCurrentCertificateBarMarkClass(certificate_name) {
      let result = '';

      if (certificate_name === 'Beryl' && this.companyHasThisCertification(certificate_name))
        result = { 'progressBar__bar-mark--beryl': true };
      if (certificate_name === 'Turquoise' && this.companyHasThisCertification(certificate_name))
        result = { 'progressBar__bar-mark--turquoise': true };
      if (certificate_name === 'Jade' && this.companyHasThisCertification(certificate_name))
        result = { 'progressBar__bar-mark--jade': true };
      if (certificate_name === 'Sapphire' && this.companyHasThisCertification(certificate_name))
        result = { 'progressBar__bar-mark--sapphire': true };

      return result;
    },
    companyHasThisCertification(certificate_name) {
      if (this.all_achieved_internal_certificates.length > 0) {
        return this.all_achieved_internal_certificates.find(function (internal_certificate) {
          return internal_certificate.certification.name === certificate_name;
        });
      }
    },
    getSortedInternalCertificates() {
      let sorted_internal_certificates = [];
      if (this.all_achieved_internal_certificates.length > 1) {
        sorted_internal_certificates = this.all_achieved_internal_certificates.sort(function (a, b) {
          return a.certification_weight - b.certification_weight;
        });
      } else {
        sorted_internal_certificates = this.all_achieved_internal_certificates;
      }
      return sorted_internal_certificates;
    },
  },
};
</script>

<style scoped></style>
